// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title___S8a_","selects":"Documents_selects__8RTl6"};